import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Shield, Brain, BarChart3, Calendar, FileText, TrendingUp } from 'lucide-react';

const values = [
  {
    icon: Shield,
    title: 'Rate Parity Monitoring',
    description: 'Track your rates across 15+ OTAs in real-time. Detect undercuts instantly and protect your direct booking revenue.',
  },
  {
    icon: Brain,
    title: 'AI-Powered Insights',
    description: 'Get intelligent pricing recommendations powered by Prowen AI. Analyze market trends and optimize your revenue strategy.',
  },
  {
    icon: BarChart3,
    title: 'Competitive Analysis',
    description: 'Monitor competitor pricing, ratings, and market positioning. Know exactly where you stand in your compset.',
  },
  {
    icon: Calendar,
    title: 'Demand & Events Calendar',
    description: 'Track local events, conferences, and holidays that impact demand. Plan your pricing strategy ahead of time.',
  },
  {
    icon: FileText,
    title: 'PDF Report Generation',
    description: 'Generate professional reports with one click. Share insights with stakeholders in beautifully formatted PDFs.',
  },
  {
    icon: TrendingUp,
    title: 'Advanced Analytics',
    description: 'Deep dive into OTA performance, revenue leakage analysis, and market share trends with interactive charts.',
  },
];

export default function ValueProposition() {
  return (
    <section id="product" className="py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-accent uppercase tracking-wider mb-3">
            Platform Features
          </p>
          <p className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Boost Hotel Bookings with AI-Driven Pricing Intelligence
          </p>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Use AI-driven pricing intelligence to track competitor rates, monitor OTA parity, and optimize your pricing strategy to increase bookings and maximize hotel revenue.
          </p>
        </div>

        {/* Value Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {values.map((value, index) => (
            <Card
              key={index}
              className="group card-hover bg-card border-border/50 overflow-hidden"
            >
              <CardContent className="p-6 lg:p-8 flex flex-col h-full">
                <div className="mb-5">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                    <value.icon className="w-6 h-6 text-primary" />
                  </div>
                </div>
                <h3 className="font-heading text-xl font-semibold text-foreground mb-3">
                  {value.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {value.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
